import { useState } from 'react'
import { useSearchParams } from 'react-router-dom'

import { ApiError, api } from '@/api/client'
import type { BookingResult } from '@/api/types'
import * as d from '@/lib/dates'
import { STATUS_LABELS, money } from '@/lib/format'

export function BookingStatusPage() {
  const [params] = useSearchParams()
  const [reference, setReference] = useState(params.get('reference') ?? '')
  const [email, setEmail] = useState(params.get('email') ?? '')
  const [result, setResult] = useState<BookingResult | null>(null)
  const [error, setError] = useState<string | null>(null)
  const [busy, setBusy] = useState(false)

  async function lookup(e: React.FormEvent) {
    e.preventDefault()
    setBusy(true)
    setError(null)
    try {
      setResult(await api.bookingStatus(reference.trim(), email.trim()))
    } catch (err) {
      setResult(null)
      // Номер брони короткий, поэтому подбор нужно затруднить: не подсказываем,
      // что именно не сошлось — код или почта.
      setError(err instanceof ApiError ? err.message : 'Не удалось найти бронь')
    } finally {
      setBusy(false)
    }
  }

  return (
    <section className="section status">
      <h1 className="display">Моя бронь</h1>
      <p className="muted">Введите номер брони и email, который указывали при оформлении.</p>

      <form className="status__form" onSubmit={lookup}>
        <label className="field">
          <span className="field__label">Номер брони</span>
          <input
            className="field__input"
            value={reference}
            onChange={(e) => setReference(e.target.value.toUpperCase())}
            placeholder="AB12CD34"
            required
          />
        </label>
        <label className="field">
          <span className="field__label">Email</span>
          <input
            className="field__input"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </label>
        <button className="button button--primary" type="submit" disabled={busy}>
          {busy ? 'Ищем…' : 'Найти'}
        </button>
      </form>

      {error && <p className="error">{error}</p>}

      {result && (
        <div className="status__card">
          <h2 className="status__name">{result.property_name}</h2>
          <p className="status__state">{STATUS_LABELS[result.status] ?? result.status}</p>
          <dl className="summary__list">
            <div>
              <dt>Номер брони</dt>
              <dd>{result.reference}</dd>
            </div>
            <div>
              <dt>Даты</dt>
              <dd>
                {d.formatLong(result.check_in)} — {d.formatLong(result.check_out)}
              </dd>
            </div>
            <div>
              <dt>Сумма</dt>
              <dd>{money(result.total_amount, result.currency)}</dd>
            </div>
          </dl>
        </div>
      )}
    </section>
  )
}
